var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getCreate2Address } from '@ethersproject/address';
import { keccak256, pack } from '@ethersproject/solidity';
import { TradeType, WETH9 } from '@uniswap/sdk-core';
import IUniswapV2Router02Json from '@uniswap/v2-periphery/build/IUniswapV2Router02.json';
import { FACTORY_ADDRESS_MAP, INIT_CODE_HASH } from '@uniswap/v2-sdk';
import uniswapV2PairContract from '../../../../abis/uniswapV2PairContract.json';
import BN from 'bignumber.js';
import { ethers } from 'ethers';
import { Config } from '../../../../Fct/Config';
import { getPlugin } from '../../../../Fct/plugins/helpers';
import { WETH_ADDRESS_MAP } from '../../../../Fct/plugins/utility/helpers/contracts';
import BigDecimal from 'js-big-decimal';
import { weiToCurrency } from '../../../../utils/tryParseCurrencyAmount';
import { Uniswap as UniswapPlugins } from '../../uniswap';
import { ROUTER_V2_ADDRESS } from '../constants';
import getClientSideSmartOrderRouterTrade from './getClientSideSmartOrderRouterTrade';
import { getMethodName } from './getMethodName';
import getSlippage from './getSlippage';
import { getSwapCall } from './getSwapCall';
import { getIsNative, getToken } from './getToken';
import { Field } from './types/swap';
import { TradeState } from './types/types';
var IUniswapV2Router02ABI = IUniswapV2Router02Json.abi;
export var INVALID_TRADE = { state: TradeState.INVALID, trade: undefined };
export var UNISWAP_TYPE;
(function (UNISWAP_TYPE) {
    UNISWAP_TYPE["EXACT_INPUT"] = "EXACT_INPUT";
    UNISWAP_TYPE["EXACT_OUTPUT"] = "EXACT_OUTPUT";
})(UNISWAP_TYPE || (UNISWAP_TYPE = {}));
var REJECT_PREV_REQUEST_ERROR = 'reject previous values';
var Uniswap = /** @class */ (function (_super) {
    __extends(Uniswap, _super);
    function Uniswap() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.MINIMUM_LIQUIDITY = Math.pow(10, 3);
        _this.promiseReject = undefined;
        _this.getSwapParams = function (_a) {
            var input = _a.input, output = _a.output, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var swapValues, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.getLastSwapParamsV2({ input: input, output: output, slippage: slippage })];
                        case 1:
                            swapValues = _b.sent();
                            return [2 /*return*/, swapValues];
                        case 2:
                            e_1 = _b.sent();
                            if (e_1 === REJECT_PREV_REQUEST_ERROR) {
                                return [2 /*return*/, undefined];
                            }
                            throw new Error(e_1);
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getAmountParams = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                var path, e_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.getLastInputValuesV2({ input: input, output: output })];
                        case 1:
                            path = _b.sent();
                            return [2 /*return*/, path];
                        case 2:
                            e_2 = _b.sent();
                            if (e_2 === REJECT_PREV_REQUEST_ERROR) {
                                return [2 /*return*/, undefined];
                            }
                            throw new Error(e_2);
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getPairAddress = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            var isToken0Native = getIsNative(token0);
            var inputToken = token0;
            if (isToken0Native) {
                inputToken = WETH9[Number(_this.chainId)].address;
            }
            var isToken1Native = getIsNative(token1);
            var outputToken = token1;
            if (isToken1Native) {
                outputToken = WETH9[Number(_this.chainId)].address;
            }
            var pairAddress = getCreate2Address(FACTORY_ADDRESS_MAP[Number(_this.chainId)], keccak256(['bytes'], [pack(['address', 'address'], inputToken < outputToken ? [inputToken, outputToken] : [outputToken, inputToken])]), INIT_CODE_HASH);
            return pairAddress;
        };
        _this.isPairExist = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            return __awaiter(_this, void 0, void 0, function () {
                var pairAddress, contract, e_3;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            pairAddress = this.getPairAddress({ token0: token0, token1: token1 });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            contract = new ethers.Contract(pairAddress, uniswapV2PairContract, this.library);
                            return [4 /*yield*/, contract.factory()];
                        case 2:
                            _b.sent();
                            return [2 /*return*/, true];
                        case 3:
                            e_3 = _b.sent();
                            //console.error({ error: e })
                            return [2 /*return*/, false];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getTotalSupply = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            return __awaiter(_this, void 0, void 0, function () {
                var pairAddress, isExist, contract, totalSupply;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            pairAddress = this.getPairAddress({ token0: token0, token1: token1 });
                            return [4 /*yield*/, this.isPairExist({ token0: token0, token1: token1 })];
                        case 1:
                            isExist = _b.sent();
                            if (!isExist)
                                return [2 /*return*/];
                            contract = new ethers.Contract(pairAddress, ['function totalSupply() view returns (uint256)'], this.library);
                            return [4 /*yield*/, contract.totalSupply()];
                        case 2:
                            totalSupply = _b.sent();
                            return [2 /*return*/, totalSupply];
                    }
                });
            });
        };
        _this.getReserves = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            return __awaiter(_this, void 0, void 0, function () {
                var pairAddress, isExist, contract, reserves;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            pairAddress = this.getPairAddress({ token0: token0, token1: token1 });
                            return [4 /*yield*/, this.isPairExist({ token0: token0, token1: token1 })];
                        case 1:
                            isExist = _b.sent();
                            if (!isExist)
                                return [2 /*return*/, undefined];
                            contract = new ethers.Contract(pairAddress, ['function getReserves() view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)'], this.library);
                            return [4 /*yield*/, contract.getReserves()];
                        case 2:
                            reserves = (_b.sent());
                            if (!reserves || !reserves.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, token0 < token1
                                    ? [reserves[0].toString(), reserves[1].toString(), token0, token1]
                                    : [reserves[1].toString(), reserves[0].toString(), token0, token1]];
                    }
                });
            });
        };
        _this.getLPTokenBalance = function (_a) {
            var token0 = _a.token0, token1 = _a.token1, address = _a.address;
            return __awaiter(_this, void 0, void 0, function () {
                var pairAddress, isExist, contract, balance;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            pairAddress = this.getPairAddress({ token0: token0, token1: token1 });
                            return [4 /*yield*/, this.isPairExist({ token0: token0, token1: token1 })];
                        case 1:
                            isExist = _b.sent();
                            if (!isExist)
                                return [2 /*return*/, undefined];
                            contract = new ethers.Contract(pairAddress, ['function balanceOf(address _owner) view returns (uint256 balance)'], this.library);
                            return [4 /*yield*/, contract.balanceOf(address)];
                        case 2:
                            balance = (_b.sent());
                            if (!balance)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, balance.toString()];
                    }
                });
            });
        };
        _this.getToken1LiquidityRate = function (_a) {
            var token0 = _a.token0, token1 = _a.token1;
            return __awaiter(_this, void 0, void 0, function () {
                var isToken0Native, inputToken, isToken1Native, outputToken, isExist, reserves, precision, rateEth;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            isToken0Native = getIsNative(token0);
                            inputToken = token0;
                            if (isToken0Native) {
                                inputToken = WETH9[Number(this.chainId)].address;
                            }
                            isToken1Native = getIsNative(token1);
                            outputToken = token1;
                            if (isToken1Native) {
                                outputToken = WETH9[Number(this.chainId)].address;
                            }
                            return [4 /*yield*/, this.isPairExist({ token0: inputToken, token1: outputToken })];
                        case 1:
                            isExist = _b.sent();
                            if (!isExist)
                                return [2 /*return*/, undefined];
                            return [4 /*yield*/, this.getReserves({ token0: inputToken, token1: outputToken })];
                        case 2:
                            reserves = _b.sent();
                            if (!reserves)
                                return [2 /*return*/, undefined];
                            precision = 18;
                            rateEth = new BigDecimal(reserves[1]).divide(new BigDecimal(reserves[0]), precision).getValue();
                            return [2 /*return*/, rateEth];
                    }
                });
            });
        };
        _this.estimateLiquidityOutputOnAddLiquidity = function (_a) {
            var token0 = _a.token0, token1 = _a.token1, amount0 = _a.amount0, amount1 = _a.amount1;
            return __awaiter(_this, void 0, void 0, function () {
                var totalSupplyBignum, totalSupply, amount0BN, amount1BN, reserves, a0, a1, compareTo;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getTotalSupply({ token0: token0, token1: token1 })];
                        case 1:
                            totalSupplyBignum = (_b.sent());
                            totalSupply = totalSupplyBignum ? totalSupplyBignum.toString() : undefined;
                            if (!(!totalSupply || totalSupply === '0')) return [3 /*break*/, 2];
                            amount0BN = new BN(amount0);
                            amount1BN = new BN(amount1);
                            return [2 /*return*/, amount0BN.multipliedBy(amount1BN).sqrt().minus(this.MINIMUM_LIQUIDITY).toFixed(0)];
                        case 2: return [4 /*yield*/, this.getReserves({ token0: token0, token1: token1 })];
                        case 3:
                            reserves = _b.sent();
                            if (!reserves)
                                return [2 /*return*/, undefined];
                            a0 = new BigDecimal(amount0)
                                .multiply(new BigDecimal(totalSupply))
                                .divide(new BigDecimal(reserves[0]), 18)
                                .floor()
                                .getValue();
                            a1 = new BigDecimal(amount1)
                                .multiply(new BigDecimal(totalSupply))
                                .divide(new BigDecimal(reserves[1]), 18)
                                .floor()
                                .getValue();
                            compareTo = BigDecimal.compareTo(a0, a1);
                            return [2 /*return*/, compareTo < 1 ? a0 : a1];
                    }
                });
            });
        };
        _this.estimateTokensAmountOnRemoveLiquidity = function (_a) {
            var token0 = _a.token0, token1 = _a.token1, liquidity = _a.liquidity;
            return __awaiter(_this, void 0, void 0, function () {
                var totalSupplyBignum, totalSupply, reserves, a0, a1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getTotalSupply({ token0: token0, token1: token1 })];
                        case 1:
                            totalSupplyBignum = (_b.sent());
                            totalSupply = totalSupplyBignum ? totalSupplyBignum.toString() : undefined;
                            if (!totalSupply || totalSupply === '0') {
                                return [2 /*return*/, undefined];
                            }
                            return [4 /*yield*/, this.getReserves({ token0: token0, token1: token1 })];
                        case 2:
                            reserves = _b.sent();
                            if (!reserves) {
                                return [2 /*return*/, undefined];
                            }
                            a0 = new BigDecimal(liquidity)
                                .multiply(new BigDecimal(reserves[0]))
                                .divide(new BigDecimal(totalSupply), 18)
                                .floor()
                                .getValue();
                            a1 = new BigDecimal(liquidity)
                                .multiply(new BigDecimal(reserves[1]))
                                .divide(new BigDecimal(totalSupply), 18)
                                .floor()
                                .getValue();
                            return [2 /*return*/, [a0, a1]];
                    }
                });
            });
        };
        _this.getPathAmountOut = function (_a) {
            var amountIn = _a.amountIn, path = _a.path;
            return __awaiter(_this, void 0, void 0, function () {
                var contract, res, e_4;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            contract = new ethers.Contract(ROUTER_V2_ADDRESS[String(this.chainId)], IUniswapV2Router02ABI, this.library);
                            return [4 /*yield*/, contract.getAmountsOut(amountIn, path)];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, res];
                        case 2:
                            e_4 = _b.sent();
                            console.error({ error: e_4 });
                            return [2 /*return*/];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getPathAmountIn = function (_a) {
            var amountOut = _a.amountOut, path = _a.path;
            return __awaiter(_this, void 0, void 0, function () {
                var contract, res, e_5;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            contract = new ethers.Contract(ROUTER_V2_ADDRESS[String(this.chainId)], IUniswapV2Router02ABI, this.library);
                            return [4 /*yield*/, contract.getAmountsIn(amountOut, path)];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, res];
                        case 2:
                            e_5 = _b.sent();
                            console.error({ error: e_5 });
                            return [2 /*return*/];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getToken = function (swapToken) {
            var chainId = _this.chainId;
            return getToken(swapToken, chainId);
        };
        _this.getLastInputValuesV2 = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var _b;
                return __generator(this, function (_c) {
                    (_b = this.promiseReject) === null || _b === void 0 ? void 0 : _b.call(this, REJECT_PREV_REQUEST_ERROR);
                    return [2 /*return*/, new Promise(function (resolve, regect) { return __awaiter(_this, void 0, void 0, function () {
                            var currencyIn, currencyOut, invalideTrade, isExactIn, methodName, tradeType, amount, amountSpecified, values, path, initParams;
                            var _a, _b, _c, _d, _e;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0:
                                        this.promiseReject = regect;
                                        currencyIn = this.getToken(input.currency);
                                        currencyOut = this.getToken(output.currency);
                                        invalideTrade = this.validateSwapInput({ input: input, output: output });
                                        isExactIn = input.amount ? true : false;
                                        methodName = isExactIn ? 'getAmountsOut' : 'getAmountsIn';
                                        if (invalideTrade) {
                                            return [2 /*return*/, resolve(__assign(__assign({}, invalideTrade), { methodName: methodName }))];
                                        }
                                        tradeType = isExactIn ? TradeType.EXACT_INPUT : TradeType.EXACT_OUTPUT;
                                        amount = isExactIn ? input.amount : output.amount;
                                        amountSpecified = weiToCurrency(amount, isExactIn ? currencyIn : currencyOut);
                                        return [4 /*yield*/, this.getBestTrade({
                                                tradeType: tradeType,
                                                amountSpecified: amountSpecified,
                                                otherCurrency: isExactIn ? currencyOut : currencyIn,
                                                protocol: 'V2',
                                            })];
                                    case 1:
                                        values = _f.sent();
                                        path = (_a = values === null || values === void 0 ? void 0 : values.trade) === null || _a === void 0 ? void 0 : _a.routes[0].path.map(function (token) {
                                            return token.address;
                                        });
                                        initParams = {
                                            inputAmount: (_b = values === null || values === void 0 ? void 0 : values.trade) === null || _b === void 0 ? void 0 : _b.inputAmount.quotient.toString(10),
                                            outputAmount: (_c = values === null || values === void 0 ? void 0 : values.trade) === null || _c === void 0 ? void 0 : _c.outputAmount.quotient.toString(10),
                                            methodName: methodName,
                                            protocol: 'UNISWAP',
                                            plugin: getPlugin({
                                                plugins: UniswapPlugins.getters,
                                                methodName: methodName,
                                            }),
                                            state: this.getTradeState((values === null || values === void 0 ? void 0 : values.state) || 0),
                                        };
                                        if (isExactIn) {
                                            resolve(__assign(__assign({}, initParams), { params: {
                                                    methodParams: {
                                                        path: path,
                                                        amountIn: (_d = values === null || values === void 0 ? void 0 : values.trade) === null || _d === void 0 ? void 0 : _d.inputAmount.quotient.toString(10),
                                                    },
                                                } }));
                                        }
                                        resolve(__assign(__assign({}, initParams), { params: {
                                                methodParams: {
                                                    path: path,
                                                    amountOut: (_e = values === null || values === void 0 ? void 0 : values.trade) === null || _e === void 0 ? void 0 : _e.outputAmount.quotient.toString(10),
                                                },
                                            } }));
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        _this.getLastSwapParamsV2 = function (_a) {
            var input = _a.input, output = _a.output, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var _b;
                return __generator(this, function (_c) {
                    (_b = this.promiseReject) === null || _b === void 0 ? void 0 : _b.call(this, REJECT_PREV_REQUEST_ERROR);
                    return [2 /*return*/, new Promise(function (resolve, regect) { return __awaiter(_this, void 0, void 0, function () {
                            var values;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.promiseReject = regect;
                                        return [4 /*yield*/, this.getSwapValuesV2({ input: input, output: output, slippage: slippage })];
                                    case 1:
                                        values = _a.sent();
                                        resolve(values);
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        _this.getSwapValuesV2 = function (_a) {
            var input = _a.input, output = _a.output, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, this.getSwapValues({
                            input: input,
                            output: output,
                            protocol: 'V2',
                            slippage: slippage,
                        })];
                });
            });
        };
        _this.getSwapValuesV3 = function (_a) {
            var input = _a.input, output = _a.output;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, this.getSwapValues({
                            input: input,
                            output: output,
                            protocol: 'V3',
                        })];
                });
            });
        };
        _this.getTradeState = function (stateindex) {
            switch (stateindex) {
                case 3:
                    return 'VALID';
                default:
                    return 'INVALID';
            }
        };
        _this.validateSwapInput = function (_a) {
            var _b, _c;
            var input = _a.input, output = _a.output;
            var invalidTrade = {
                inputAmount: '0',
                outputAmount: '0',
                state: 'INVALID',
                params: undefined,
                INPUT: {
                    currency: undefined,
                    amount: undefined,
                },
                OUTPUT: {
                    currency: undefined,
                    amount: undefined,
                },
                trade: undefined,
                slippage: undefined,
                type: undefined,
                methodName: undefined,
                protocol: 'UNISWAP',
            };
            var WETH_ADDRESS = WETH_ADDRESS_MAP[_this.chainId];
            if ((input.currency.address === WETH_ADDRESS && getIsNative(output.currency.address)) ||
                (getIsNative(input.currency.address) && output.currency.address === WETH_ADDRESS)) {
                console.error('To wrap or unwrap ETH, please use the Ether Wrap/Unwrap Plugin');
                return invalidTrade;
            }
            if (((_b = input.currency.address) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = output.currency.address) === null || _c === void 0 ? void 0 : _c.toLowerCase())) {
                console.error('Invalid trade');
                return invalidTrade;
            }
            if (!input.currency) {
                console.error('input currency required');
                return invalidTrade;
            }
            if (!output.currency) {
                console.error('output currency required');
                return invalidTrade;
            }
            if (!input.amount && !output.amount) {
                return invalidTrade;
            }
            return undefined;
        };
        _this.getSwapValues = function (_a) {
            var input = _a.input, output = _a.output, protocol = _a.protocol, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var invalideTrade, _b, library, account, chainId, currencyIn, currencyOut, isExactIn, blockTimestamp, swapInfo, swapCall, isExactEthInput, params, methodName, swap;
                var _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            invalideTrade = this.validateSwapInput({ input: input, output: output });
                            if (invalideTrade) {
                                return [2 /*return*/, invalideTrade];
                            }
                            _b = this, library = _b.library, account = _b.account, chainId = _b.chainId;
                            currencyIn = this.getToken(input.currency);
                            currencyOut = this.getToken(output.currency);
                            isExactIn = Boolean(input.amount);
                            return [4 /*yield*/, this.getLastBlock()];
                        case 1:
                            blockTimestamp = (_f.sent()).blockTimestamp;
                            return [4 /*yield*/, this.getSwapInfo({
                                    amount: input.amount || output.amount || '0',
                                    currencyIn: currencyIn,
                                    currencyOut: currencyOut,
                                    isExactIn: isExactIn,
                                    protocol: protocol,
                                    slippage: slippage,
                                })];
                        case 2:
                            swapInfo = _f.sent();
                            return [4 /*yield*/, getSwapCall({ library: library, chainId: chainId, account: account, swapInfo: swapInfo, blockTimestamp: blockTimestamp, protocol: protocol })];
                        case 3:
                            swapCall = _f.sent();
                            isExactEthInput = this.getToken(input.currency).isNative && isExactIn;
                            params = swapCall === null || swapCall === void 0 ? void 0 : swapCall.params;
                            methodName = getMethodName({
                                isExactInput: isExactIn,
                                isInputNative: this.getToken(input.currency).isNative,
                                isOutputNative: this.getToken(output.currency).isNative,
                                protocol: protocol,
                                params: params,
                            });
                            swap = __assign(__assign({}, swapInfo), { inputAmount: (_c = swapInfo.INPUT.amount) === null || _c === void 0 ? void 0 : _c.quotient.toString(10), outputAmount: (_d = swapInfo.OUTPUT.amount) === null || _d === void 0 ? void 0 : _d.quotient.toString(10), state: this.getTradeState(((_e = swapInfo === null || swapInfo === void 0 ? void 0 : swapInfo.trade) === null || _e === void 0 ? void 0 : _e.state) || 0), params: {
                                    methodParams: swapCall === null || swapCall === void 0 ? void 0 : swapCall.params,
                                    value: isExactEthInput && protocol === 'V2' ? params.amountIn : undefined,
                                }, methodName: methodName, protocol: 'UNISWAP', plugin: getPlugin({
                                    plugins: __assign({}, UniswapPlugins.actions),
                                    methodName: methodName,
                                }) });
                            return [2 /*return*/, swap];
                    }
                });
            });
        };
        _this.getSwapInfo = function (_a) {
            var amount = _a.amount, currencyIn = _a.currencyIn, currencyOut = _a.currencyOut, protocol = _a.protocol, isExactIn = _a.isExactIn, slippage = _a.slippage;
            return __awaiter(_this, void 0, void 0, function () {
                var parsedAmount, hasAmounts, trade, amountIn, amountOut;
                var _b;
                var _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            parsedAmount = weiToCurrency(amount, (_c = (isExactIn ? currencyIn : currencyOut)) !== null && _c !== void 0 ? _c : undefined);
                            hasAmounts = currencyIn || currencyOut;
                            return [4 /*yield*/, this.getBestTrade({
                                    tradeType: isExactIn ? TradeType.EXACT_INPUT : TradeType.EXACT_OUTPUT,
                                    protocol: protocol,
                                    amountSpecified: hasAmounts ? parsedAmount : undefined,
                                    otherCurrency: isExactIn ? currencyOut : currencyIn,
                                })];
                        case 1:
                            trade = _f.sent();
                            amountIn = isExactIn ? parsedAmount : (_d = trade === null || trade === void 0 ? void 0 : trade.trade) === null || _d === void 0 ? void 0 : _d.inputAmount //isWrapping || isExactIn ? parsedAmount : trade.trade?.inputAmount
                            ;
                            amountOut = !isExactIn ? parsedAmount : (_e = trade === null || trade === void 0 ? void 0 : trade.trade) === null || _e === void 0 ? void 0 : _e.outputAmount //isWrapping || !isExactIn ? parsedAmount : trade.trade?.outputAmount
                            ;
                            return [2 /*return*/, (_b = {},
                                    _b[Field.INPUT] = {
                                        currency: currencyIn,
                                        amount: amountIn,
                                    },
                                    _b[Field.OUTPUT] = {
                                        currency: currencyOut,
                                        amount: amountOut,
                                    },
                                    _b.trade = trade,
                                    _b.slippage = getSlippage(slippage),
                                    _b.type = isExactIn ? UNISWAP_TYPE.EXACT_INPUT : UNISWAP_TYPE.EXACT_OUTPUT,
                                    _b)];
                    }
                });
            });
        };
        /**
         * Returns the best v2+v3 trade for a desired swap.
         * @param tradeType whether the swap is an exact in/out
         * @param amountSpecified the exact amount to swap in/out
         * @param otherCurrency the desired output/payment currency
         */
        _this.getBestTrade = function (_a) {
            var tradeType = _a.tradeType, amountSpecified = _a.amountSpecified, protocol = _a.protocol, otherCurrency = _a.otherCurrency;
            return __awaiter(_this, void 0, void 0, function () {
                var library, clientSORTradeObject, tradeObject, lastTrade, state, trade, _b, currencyIn, currencyOut, isStale;
                var _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            library = this.library;
                            return [4 /*yield*/, getClientSideSmartOrderRouterTrade({
                                    library: library,
                                    tradeType: tradeType,
                                    protocol: protocol,
                                    amountSpecified: amountSpecified,
                                    otherCurrency: otherCurrency,
                                })];
                        case 1:
                            clientSORTradeObject = _e.sent();
                            tradeObject = clientSORTradeObject;
                            lastTrade = tradeObject === null || tradeObject === void 0 ? void 0 : tradeObject.trade;
                            // Return the last trade while syncing/loading to avoid jank from clearing the last trade while loading.
                            // If the trade is unsettled and not stale, return the last trade as a placeholder during settling.
                            if (!tradeObject)
                                return [2 /*return*/];
                            state = tradeObject.state, trade = tradeObject.trade;
                            // If the trade is in a settled state, return it.
                            if (state === TradeState.INVALID)
                                return [2 /*return*/, INVALID_TRADE];
                            if ((state !== TradeState.LOADING && state !== TradeState.SYNCING) || trade)
                                return [2 /*return*/, tradeObject];
                            _b = __read(tradeType === TradeType.EXACT_INPUT
                                ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency]
                                : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency], 2), currencyIn = _b[0], currencyOut = _b[1];
                            isStale = (currencyIn && !((_c = lastTrade === null || lastTrade === void 0 ? void 0 : lastTrade.inputAmount) === null || _c === void 0 ? void 0 : _c.currency.equals(currencyIn))) ||
                                (currencyOut && !((_d = lastTrade === null || lastTrade === void 0 ? void 0 : lastTrade.outputAmount) === null || _d === void 0 ? void 0 : _d.currency.equals(currencyOut)));
                            if (isStale)
                                return [2 /*return*/, tradeObject];
                            return [2 /*return*/, { state: state, trade: lastTrade }];
                    }
                });
            });
        };
        return _this;
    }
    return Uniswap;
}(Config));
export { Uniswap };
